module.exports = __webpack_public_path__ + "static/media/circle-view-on.2c293763.svg";